import { Helpers } from '@app/shared/helpers';
import {
	BaseModelSearchParams,
	BaseModelSearchParamsInterface,
} from '@app/abstracts';

/** Used to export and import search params */
export interface FormationThematiqueSearchParamsInterface
	extends BaseModelSearchParamsInterface {
	_sort?:
		| '_id'
		| 'created_at'
		| 'name'
		| 'formateur'
		| 'start_date'
		| 'formation';
	_id?: string[];
	_text?: string;
	name?: string;
	formateur?: string;
	start_date?: string | number | Date;
	start_date__min?: string | number | Date;
	start_date__max?: string | number | Date;
	formation?: string[];
}

/** Manage formation thematique search params */
export class FormationThematiqueSearchParams extends BaseModelSearchParams<
	FormationThematiqueSearchParamsInterface
> {
	/** @inheritDoc */
	fromObject(input: Partial<FormationThematiqueSearchParamsInterface>): void {
		// Clone object with allowed keys only
		const props = {} as FormationThematiqueSearchParamsInterface;
		this.allowedKeys().map((key: string) => {
			if (typeof input[key] !== 'undefined') {
				props[key] = input[key];
			}
		});

		// Keep default values
		if (typeof props._page === 'undefined') {
			props._page = this.defaultPage;
		}
		if (typeof props._limit === 'undefined') {
			props._limit = this.defaultLimit;
		}
		if (typeof props._sort === 'undefined') {
			props._sort = this.defaultSort;
		}
		if (typeof props._order === 'undefined') {
			props._order = this.defaultOrder;
		}
		// Convert potentially multiple primary keys
		if (typeof props._id === 'string') {
			props._id = (<string>props._id).split(',').filter((s) => s.length);
		}

		// Convert dates for start date
		if (typeof props.start_date !== 'undefined') {
			props.start_date = Helpers.convertToDate(props.start_date);
		}
		if (typeof props.start_date__min !== 'undefined') {
			props.start_date__min = Helpers.convertToDate(
				props.start_date__min
			);
		}
		if (typeof props.start_date__max !== 'undefined') {
			props.start_date__max = Helpers.convertToDate(
				props.start_date__max
			);
		}

		// Assign values
		this.props = props;
		this.next();
	}
	/** @inheritDoc */
	toObject(): FormationThematiqueSearchParamsInterface {
		// Filter not allowed, undefined and null values
		const props = {} as FormationThematiqueSearchParamsInterface;
		this.allowedKeys().map(Helpers.prepareObjectForApi(this.props, props));

		// Avoid conflict in value of start date
		if (typeof props.start_date !== 'undefined') {
			delete props.start_date__min;
			delete props.start_date__max;
		}

		return props;
	}
	/** @inheritDoc */
	protected allowedKeys(): string[] {
		return super
			.allowedKeys()
			.concat([
				'_id',
				'_text',
				'name',
				'formateur',
				'start_date',
				'start_date__min',
				'start_date__max',
				'formation',
			]);
	}
}
